var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "vs-row",
        {
          staticClass: "p-3 mt-2 shadow-sm bg-white",
          class: { selected: _vm.file.id === _vm.actualBilling.id }
        },
        [
          _c(
            "vs-col",
            { attrs: { "vs-lg": "11" } },
            [
              _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    { attrs: { "vs-lg": "2", "data-cy": "file-status" } },
                    [
                      _c("div", { attrs: { "data-cy": "file-receptor" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.file.receptor.razonSocial) + " "
                        ),
                        _c("br"),
                        _vm._v(" " + _vm._s(_vm.file.receptor.iut) + " ")
                      ])
                    ]
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-lg": "8" } },
                    [
                      _c(
                        "vs-row",
                        [
                          _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("amount")(_vm.file.detalle.monto)
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.file.detalle.moneda) + " "
                              )
                            ]
                          ),
                          _c("vs-col", {
                            attrs: {
                              "vs-lg": "6",
                              "vs-sm": "3",
                              "vs-xs": "12"
                            },
                            domProps: { innerHTML: _vm._s(_vm.detalle) }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.screenSizeFull
                ? _c("RowLargeBilling", { attrs: { file: _vm.file } })
                : _vm._e(),
              !_vm.screenSizeFull
                ? _c("RowSmallBilling", { attrs: { file: _vm.file } })
                : _vm._e()
            ],
            1
          ),
          _c(
            "vs-col",
            {
              attrs: {
                "vs-lg": "1",
                "vs-type": "flex",
                "vs-justify": "center",
                "vs-align": "center"
              }
            },
            [
              _vm._t(
                "actions",
                [
                  _c("BillingOptions", {
                    ref: "file-options-" + _vm.file.id,
                    attrs: { file: _vm.file }
                  })
                ],
                { file: _vm.file }
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }